import * as React from "react";
import { ImageLoader } from "../ImageLoader";
import * as s from "./AuthPageLayout.style.css";

export interface AuthPageLayoutBackground {
  /** Full-resolution background image (progressive blur-up via ImageLoader). */
  imageUrl?: string;
  /** Tiny LQIP shown blurred while `imageUrl` loads (ListView-style entrance). */
  placeholderImageUrl?: string;
  /** Rendered as a full-bleed CSS gradient when set and imageUrl isn't. */
  gradient?: string;
}

export interface AuthPageLayoutProps {
  children: React.ReactNode;
  footer?: React.ReactNode;
  background?: AuthPageLayoutBackground;
}

export function AuthPageLayout({ children, footer, background }: AuthPageLayoutProps) {
  // Falls back silently (just the theme background, no broken-image icon) if
  // the configured imageUrl 404s — e.g. an asset that hasn't been added yet.
  const [imageFailed, setImageFailed] = React.useState(false);
  const showImage = !!background?.imageUrl && !imageFailed;
  const showGradient = !showImage && !!background?.gradient;

  React.useEffect(() => {
    setImageFailed(false);
  }, [background?.imageUrl]);

  return (
    <div className={s.page}>
      {(showImage || showGradient) && (
        <div className={s.backgroundLayer} aria-hidden>
          {showImage ? (
            <ImageLoader
              src={background!.imageUrl!}
              placeholderSrc={background!.placeholderImageUrl}
              className={s.backgroundImage}
              onError={() => setImageFailed(true)}
            />
          ) : (
            <div className={s.backgroundGradient} style={{ background: background!.gradient }} />
          )}
          <div className={s.backgroundScrim} />
        </div>
      )}
      <main className={s.main}>{children}</main>
      {footer ? <footer className={s.footerBar}>{footer}</footer> : null}
    </div>
  );
}

export function AuthPageFooter() {
  return (
    <p className={s.footer}>
      <a href="#" className={s.footerLink} onClick={(e) => e.preventDefault()}>
        Support
      </a>
      {" · "}
      <a href="#" className={s.footerLink} onClick={(e) => e.preventDefault()}>
        Privacy
      </a>
      {" · "}
      v1.0.0
    </p>
  );
}
